import { DataType } from '@/screens/Order/Pages/EditOrder/components/ProductRequirementForm/measurement.column'
import HeaderComponent from '@/screens/SystemConfigure/Components/HeaderComponent/HeaderComponent'
import PopUpMenu from '@/screens/SystemConfigure/Components/PopUpMenu/PopUpMenu'
import ToolbarComponent from '@/screens/SystemConfigure/Components/ToolbarComponent/ToolbarComponent'
import { Space } from 'antd'
import Table, { ColumnsType } from 'antd/lib/table'
import { useEffect, useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import AddPropertyModal from './AddPropertyModal/AddPropertyModal'
import './Property.style.less'
import { deleteProperty, getProperties } from '../../DataManagement.transform'
import { isEmptyValue } from '@/utils/common'
import { lowerCase, orderBy } from 'lodash'

function Property() {
  const [modalProperty, setModalProperty] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const [listData, setlistData] = useState(null)

  const onEdit = (data) => {
    setSelectedItem(data)
    setModalProperty(true)
  }

  const onOpenModal = () => {
    setModalProperty(true)
    setSelectedItem(null)
  }

  const deleteMutation = useMutation(async (id: string) => {
    await deleteProperty(id)
  })

  const onDelete = async (id) => {
    await deleteMutation.mutateAsync(id)
    await refetch()
  }

  const columns: ColumnsType<DataType> = [
    {
      title: 'id',
      dataIndex: 'id',
      width: '0%',
      key: 'id',
      className: 'hide-column',
    },
    {
      title: 'NAME',
      dataIndex: 'title',
      align: 'left',
      key: 'title',
      render: (value) => (!isEmptyValue(value) ? value : <p>-</p>),
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (_, record: any) => (
        <Space size="middle">
          <PopUpMenu
            onEdit={() => {
              onEdit(record)
            }}
            onDelete={() => onDelete(record.id)}
          />
        </Space>
      ),
    },
  ]

  const { data, isLoading, refetch } = useQuery(
    'system-config-property',
    async () => {
      return await getProperties()
    }
  )

  useEffect(() => {
    if (!isEmptyValue(data)) {
      setlistData(data)
    }
  }, [data])

  const onSearch = (search: any) => {
    if (isEmptyValue(search)) {
      setlistData(data)
    } else {
      const tmp = [
        ...data.filter(
          (item) => item.name !== 'aql' && item.name !== 'inspectionType'
        ),
      ]
      const result = tmp.filter((obj) =>
        lowerCase(obj.name)?.includes(lowerCase(search))
      )
      setlistData(result)
    }
  }

  return (
    <>
      <HeaderComponent title="Property" />
      <ToolbarComponent
        onAdd={onOpenModal}
        buttonText="New Property"
        onSearch={(value) => onSearch(value)}
      />
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={orderBy(listData, ['created_date'], ['desc'])}
      />
      {modalProperty && (
        <AddPropertyModal
          visible={modalProperty}
          onClose={() => setModalProperty(false)}
          data={selectedItem}
        />
      )}
    </>
  )
}

export default Property
